import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { action } from '@ember/object';
import { or } from 'ember-truth-helpers';
import StandardModal from 'cpc-license-manager/components/standard-modal';
import FaBadgeIcon from 'cpc-license-manager/components/fa-badge-icon';
import BsForm from 'cpc-license-manager/components/bs-form';
import LegacyFeatureCallout from 'cpc-license-manager/components/legacy-feature-callout';
import LegacyStationFeature from 'cpc-license-manager/components/legacy-station-feature';
class LegacyLicenseModal extends Component {
    @service
    store;
    get saveDisabled() {
        return this.args.license?.validations.isInvalid || !this.args.license?.isDirty;
    }
    get confirmDisabled() {
        return this.args.isConfirming && isEmpty(this.args.changelog?.notes);
    }
    @action
    async onConfirm() {
        if (this.args.isConfirming) {
            await this.args.confirmAction();
        } else {
            await this.args.saveAction();
        }
    }
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    <StandardModal
      class="license-modal"
      @centered={{true}}
      @scrollable={{true}}
      @size="xl"
      @onCancel={{@cancelAction}}
      @onConfirm={{this.onConfirm}}
      ...attributes
      as |modal|
    >
      <modal.header>
        <h5 class="modal-title mb-0">
          {{#if @isEditing}}
            <FaBadgeIcon @mainIcon="key" @topIcon="pencil-alt" class="me-3" @badgeClass="bg-secondary"/>
            Edit Legacy License -
            <span class="license-id">
              {{@license.licenseId}}
            </span>
          {{else}}
            <FaBadgeIcon @mainIcon="key" @topIcon="plus-square" class="me-3" @badgeClass="bg-success"/>
            Add Legacy License
          {{/if}}
        </h5>
      </modal.header>
      <modal.body>
        {{#if @isConfirming}}
          <BsForm @model={{@changelog}} as |form|>
            <form.element @controlType="textarea" @label="Change Notes" @property="notes" class="license-change-notes"/>
          </BsForm>
        {{else}}
          <BsForm @model={{@license}} as |form|>
            <div class="row form-row">
              <div class="col-md-6 col-sm-12">
                <form.element
                  @controlType="text"
                  @label="Customer"
                  @property="customer"
                  class="license-customer" as |el|
                >
                  <el.control placeholder="Customer"/>
                </form.element>
              </div>
              <div class="col-md-6 col-sm-12">
                <form.element
                  @controlType="text"
                  @label="Project"
                  @property="project"
                  class="license-project" as |el|
                >
                  <el.control placeholder="Project"/>
                </form.element>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-md-6 col-sm-12">
                <form.element
                  @controlType="text"
                  @label="Job Number"
                  @property="jobNumber"
                  class="license-job-number"
                  as |el|
                >
                  <el.control placeholder="Job Number"/>
                </form.element>
              </div>
              <div class="col-md-6 col-sm-12">
                {{#if @license.isVirtual}}
                  <form.element
                    @controlType="text"
                    @label="Green Key #"
                    @property="greenKey"
                    class="license-green-key"
                    as |el|
                  >
                    <el.control placeholder="Green Key #"/>
                  </form.element>
                {{/if}}
                <form.element
                  @controlType="checkbox"
                  @label="Is Virtual"
                  @property="isVirtual"
                  class="license-is-virtual"
                />
              </div>
            </div>
            <div class="row form-row">
              <div class="col">
                <form.element
                  @controlType="textarea"
                  @label="Notes"
                  @property="notes"
                  class="license-notes"
                />
              </div>
            </div>
          </BsForm>

          <div class="row">
            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-analytics"
                @title="Analytics"
                @feature={{@license.analytics}}
              >
                {{#if @license.analytics}}
                  <BsForm @model={{@license.analytics}} as |form|>
                    <div class="row form-row mb-3">
                      <div class="col-md-6 col-sm-12">
                        <form.element
                          @controlType="date-time-picker"
                          @label="Expiration Date"
                          @property="expirationDate"
                          class="expiration-date"
                          as |el|
                        >
                          <el.control @dateFormat="Y-m-d" placeholder="Expiration Date"/>
                        </form.element>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <form.element
                          @controlType="number"
                          @label="Number of Dashboards"
                          @property="features.numberOfDashboards"
                          class="license-dashboards-limit"
                          as |el|
                        >
                          <el.control placeholder="Number of Dashboards"/>
                        </form.element>
                      </div>
                    </div>
                  </BsForm>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>

            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-assembly"
                @title="Assembly"
                @feature={{@license.assembly}}
              >
                {{#if @license.assembly}}
                  <BsForm @model={{@license.assembly}} @formLayout="inline" class="mb-0" as |form|>
                    <div class="row form-row mb-3">
                      <div class="col-md-6 col-sm-12">
                        <form.element
                          @controlType="date-time-picker"
                          @label="Expiration Date"
                          @property="expirationDate"
                          class="expiration-date"
                          as |el|
                        >
                          <el.control @dateFormat="Y-m-d" placeholder="Expiration Date"/>
                        </form.element>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <form.element
                          @controlType="number"
                          @label="Number of Stations"
                          @property="features.numberOfStations"
                          class="license-station-limit"
                          as |el|
                        >
                          <el.control placeholder="Number of Stations"/>
                        </form.element>
                      </div>
                    </div>
                    <div class="row form-row">
                      <div class="col-3">
                        <form.element
                          @controlType="checkbox"
                          @label="Reporting"
                          @property="features.statisticalReporting"
                          class="reporting-checkbox"
                        />
                      </div>
                    </div>
                  </BsForm>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-evision"
                @title="eVision"
                @feature={{@license.evision}}
              >
                {{#if @license.evision}}
                  <BsForm @model={{@license.evision}} @formLayout="inline" class="mb-0" as |form|>
                    <div class="row form-row mb-3">
                      <div class="col-md-6 col-sm-12">
                        <form.element
                          @controlType="date-time-picker"
                          @label="Expiration Date"
                          @property="expirationDate"
                          class="expiration-date"
                          as |el|
                        >
                          <el.control @dateFormat="Y-m-d" placeholder="Expiration Date"/>
                        </form.element>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <form.element
                          @controlType="number"
                          @label="Number of Cameras"
                          @property="features.numberOfCameras"
                          class="license-cameras-limit"
                          as |el|
                        >
                          <el.control placeholder="Number of Cameras"/>
                        </form.element>
                      </div>
                    </div>
                    <div class="row form-row">
                      <div class="col-3">
                        <form.element
                          @controlType="checkbox"
                          @label="Reporting"
                          @property="features.reporting"
                          class="mb-0 reporting-checkbox"
                        />
                      </div>
                    </div>
                  </BsForm>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>

            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-jel"
                @title="JEL"
                @feature={{@license.jel}}
              >
                {{#if @license.jel}}
                  <LegacyStationFeature @model={{@license.jel}}/>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-jem"
                @title="JEM"
                @feature={{@license.jem}}
              >
                {{#if @license.jem}}
                  <LegacyStationFeature @model={{@license.jem}}/>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>

            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-kitting"
                @title="Kitting"
                @feature={{@license.kitting}}
              >
                {{#if @license.kitting}}
                  <LegacyStationFeature @model={{@license.kitting}}/>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-oee"
                @title="OEE"
                @feature={{@license.oee}}
              >
                {{#if @license.oee}}
                  <LegacyStationFeature @model={{@license.oee}}/>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>
            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-quality"
                @title="Quality"
                @feature={{@license.quality}}
              >
                {{#if @license.quality}}
                  <LegacyStationFeature @model={{@license.quality}}/>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-12">
              <LegacyFeatureCallout
                @calloutClass="callout-license-trackAndTrace"
                @title="TNT"
                @feature={{@license.trackAndTrace}}
              >
                {{#if @license.trackAndTrace}}
                  <LegacyStationFeature @model={{@license.trackAndTrace}}/>
                {{else}}
                  <em class="text-muted">Missing Feature</em>
                {{/if}}
              </LegacyFeatureCallout>
            </div>
          </div>
        {{/if}}
      </modal.body>
      <modal.footer as |footer|>
        <footer.close class="btn-sm" />
        <footer.confirm
          class="btn-sm btn-success"
          @disabled={{or this.confirmDisabled this.saveDisabled}}
        >
          {{#if @isConfirming}}
            Confirm
          {{else}}
            Save
          {{/if}}
        </footer.confirm>
      </modal.footer>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default LegacyLicenseModal;
